import $ from 'jquery';
$(document).ready(function ($) {
    const employeeTitle = $('#employee_title');
    if (employeeTitle.length > 0) {
        if (employeeTitle.text().length > 20) {
            $('#employee_tags').addClass('hide-tags');
        }
    }
});
